import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  bannerWrapper: {
    width: "100%",
    marginBottom: "16px",
    marginTop: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  blueBanner: {
    backgroundColor: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: "8px",
    padding: "12px 18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  blueBannerLeft: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  infoIcon: {
    color: "#1d4ed8",
    fontSize: "22px !important",
    marginTop: "2px",
    flexShrink: 0,
  },
  blueBannerTitle: {
    color: "#1d39c4 !important",
    fontWeight: "700 !important",
    fontSize: "14.5px !important",
    lineHeight: "1.4 !important",
  },
  blueBannerText: {
    color: "#4b5563",
    fontWeight: "400 !important",
    fontSize: "13.5px !important",
    marginTop: "2px",
    lineHeight: "1.4 !important",
  },
  blueBannerRight: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      alignSelf: "flex-end",
    },
  },
  learnMoreBtn: {
    backgroundColor: "#ffffff !important",
    border: "1px solid #93c5fd !important",
    color: "#1d4ed8 !important",
    fontWeight: "600 !important",
    fontSize: "13px !important",
    textTransform: "none !important",
    borderRadius: "6px !important",
    padding: "4px 14px !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#f8fafc !important",
      borderColor: "#60a5fa !important",
    },
  },
  closeBtn: {
    color: "#6b7280 !important",
    padding: "4px !important",
  },
  yellowBanner: {
    backgroundColor: "#fffbeb",
    border: "1px solid #fef3c7",
    borderRadius: "8px",
    padding: "10px 18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  yellowBannerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      gap: "10px",
    },
  },
  bulbIcon: {
    color: "#f59e0b",
    fontSize: "20px !important",
    flexShrink: 0,
  },
  yellowTitle: {
    color: "#78350f",
    fontWeight: "700 !important",
    fontSize: "14px !important",
    marginRight: "4px",
  },
  featureItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  checkIcon: {
    color: "#16a34a",
    fontSize: "17px !important",
    flexShrink: 0,
  },
  featureText: {
    color: "#374151",
    fontSize: "13.5px !important",
    fontWeight: "500 !important",
  },
  noteText: {
    color: "#4b5563",
    fontSize: "13.5px !important",
  },
  dismissBtn: {
    color: "#15803d",
    fontWeight: "600 !important",
    fontSize: "13.5px !important",
    cursor: "pointer",
    userSelect: "none",
    flexShrink: 0,
    "&:hover": {
      textDecoration: "underline",
    },
    [theme.breakpoints.down("md")]: {
      alignSelf: "flex-end",
    },
  },
  dialogTitle: {
    color: "#1d39c4",
    fontWeight: "700 !important",
  },
}));

const PrescriptionTrackingBanners = () => {
  const classes = useStyles();
  const [showBlueBanner, setShowBlueBanner] = useState(() => {
    return localStorage.getItem("dismiss_rx_tracking_blue_banner") !== "true";
  });
  const [showYellowBanner, setShowYellowBanner] = useState(() => {
    return localStorage.getItem("dismiss_rx_tracking_yellow_banner") !== "true";
  });
  const [learnMoreOpen, setLearnMoreOpen] = useState(false);

  const handleDismissBlue = () => {
    setShowBlueBanner(false);
    localStorage.setItem("dismiss_rx_tracking_blue_banner", "true");
  };

  const handleDismissYellow = () => {
    setShowYellowBanner(false);
    localStorage.setItem("dismiss_rx_tracking_yellow_banner", "true");
  };

  if (!showBlueBanner && !showYellowBanner) {
    return null;
  }

  return (
    <>
      <Box className={classes.bannerWrapper}>
        {showBlueBanner && (
          <Box className={classes.blueBanner}>
            <Box className={classes.blueBannerLeft}>
              <InfoIcon className={classes.infoIcon} />
              <Box>
                <Typography className={classes.blueBannerTitle}>
                  The Repeat Orders page will continue to operate as normal whether you use this page or not.
                </Typography>
                <Typography className={classes.blueBannerText}>
                  This page is optional and is only for pharmacies who want RepeatSmart to help track outstanding prescriptions and identify which ones need chasing.
                </Typography>
              </Box>
            </Box>
            <Box className={classes.blueBannerRight}>
              {/* <Button
                variant="outlined"
                className={classes.learnMoreBtn}
                onClick={() => setLearnMoreOpen(true)}
              >
                Learn more
              </Button>
              <IconButton
                size="small"
                className={classes.closeBtn}
                onClick={handleDismissBlue}
                aria-label="close banner"
              >
                <CloseIcon style={{ fontSize: 18 }} />
              </IconButton> */}
            </Box>
          </Box>
        )}
        {
        // showYellowBanner && (
        //   <Box className={classes.yellowBanner}>
        //     <Box className={classes.yellowBannerLeft}>
        //       <LightbulbOutlinedIcon className={classes.bulbIcon} />
        //       <Typography className={classes.yellowTitle}>
        //         How this helps you:
        //       </Typography>
        //       <Box className={classes.featureItem}>
        //         <CheckCircleOutlinedIcon className={classes.checkIcon} />
        //         <Typography className={classes.featureText}>
        //           See what's outstanding
        //         </Typography>
        //       </Box>
        //       <Box className={classes.featureItem}>
        //         <CheckCircleOutlinedIcon className={classes.checkIcon} />
        //         <Typography className={classes.featureText}>
        //           Identify chase ups
        //         </Typography>
        //       </Box>
        //       <Box className={classes.featureItem}>
        //         <CheckCircleOutlinedIcon className={classes.checkIcon} />
        //         <Typography className={classes.featureText}>
        //           Record when received
        //         </Typography>
        //       </Box>
        //       <Typography className={classes.noteText}>
        //         No action needed if you don't use this page.
        //       </Typography>
        //     </Box>
        //     {/* <Typography
        //       className={classes.dismissBtn}
        //       onClick={handleDismissYellow}
        //     >
        //       Dismiss
        //     </Typography> */}
        //   </Box>
        // )
        
        }

      </Box>

      {/* Learn More Information Dialog */}
      <Dialog
        open={learnMoreOpen}
        onClose={() => setLearnMoreOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className={classes.dialogTitle}>
          About Prescription Tracking
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" paragraph>
            <strong>Prescription Tracking</strong> is designed to assist pharmacies in maintaining visibility over ordered repeat prescriptions.
          </Typography>
          <Typography variant="body2" paragraph>
            • <strong>See what's outstanding:</strong> Monitor prescriptions that have been ordered from GP surgeries but have not yet been received at the pharmacy.
          </Typography>
          <Typography variant="body2" paragraph>
            • <strong>Identify chase ups:</strong> Flag prescriptions that are taking longer than expected so staff can follow up with surgeries efficiently.
          </Typography>
          <Typography variant="body2" paragraph>
            • <strong>Record when received:</strong> Mark prescriptions as received when physical or electronic scripts arrive at your pharmacy.
          </Typography>
          <Typography variant="body2" style={{ color: "#4b5563", marginTop: "12px" }}>
            Note: Your existing <strong>Repeat Orders</strong> workflow will continue working seamlessly regardless of whether you utilize Prescription Tracking.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setLearnMoreOpen(false)}
            variant="contained"
            color="primary"
            style={{ textTransform: "none", borderRadius: "6px" }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PrescriptionTrackingBanners;
